<template>
  <v-layout id="bucket-sort" row :class="{'wrap': $vuetify.breakpoint.xsOnly}">
    <v-layout :class="{'wrap': $vuetify.breakpoint.xsOnly}">
      <v-flex
        xs12
        sm3
        :class="{'pr-0': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
        <v-autocomplete
          :items="schemaFieldSets"
          append-icon="keyboard_arrow_down"
          box
          dense
          label="Fieldset"
          v-model="filter.fieldset">
        </v-autocomplete>
      </v-flex>
      <v-flex
        xs12 sm3
        :class="{'pr-0 pl-0': $vuetify.breakpoint.xsAndDown, 'pr-2 pl-2': $vuetify.breakpoint.smAndUp}">
        <v-autocomplete
          :disabled="filter.fieldset == ''"
          :items="fieldNames"
          append-icon="keyboard_arrow_down"
          box
          dense
          label="Field"
          v-model="filter.fieldName">
        </v-autocomplete>
      </v-flex>
      <v-flex
        xs12 sm3
        :class="{'pr-0 pl-0': $vuetify.breakpoint.xsAndDown, 'pr-2 pl-2': $vuetify.breakpoint.smAndUp}">
        <v-autocomplete
          :items="bucketConditions"
          append-icon="keyboard_arrow_down"
          box
          dense
          label="Condition"
          v-model="filter.condition">
        </v-autocomplete>
      </v-flex>
      <v-flex
        xs12 sm3
        :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
        <v-text-field box v-model="filter.value" label="Value"></v-text-field>
      </v-flex>
      <v-layout>
        <v-btn
          @click="deleteFilter()"
          class="mt-0 hidden-xs-only"
          icon
          id="createFilter-delete-btn"
          style="margin-top:11px !important">
          <v-icon color="error">cancel</v-icon>
        </v-btn>
        <v-btn
          @click="deleteFilter()"
          class="mt-0 ml-0 mb-3 hidden-sm-and-up text-link-button"
          color="error"
          flat
          id="createFilter-delete-btn"
          style="margin-top:-4px !important">
          <v-icon class="mr-2" color="error">cancel</v-icon>Remove above filter
        </v-btn>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>

export default {
  name: "bucket-filter",
  props: ["filter", "schema"],
  computed: {
    fieldNames() {
      let fieldNames = []
      if (this.filter.fieldset === "common") { return ["title", "current_state", "created_at", "updated_at", "last_exported_at", "last_exported_via_bucket_id", "sentiment_score", "sentiment_magnitude", "no_unread_conversations", "unresolved_task_failures"] }
      if (this.schema && this.schema.fieldsets) {
        if ((this.filter.fieldset !== "") && (Array.isArray(this.schema.fieldsets))) {
          this.schema.fieldsets.forEach(fieldSet => {
            if (this.filter.fieldset === fieldSet.name) {
              fieldNames = fieldSet.fields.map(field => field.name)
            }
          })
        }
      }
      return fieldNames
    },
    schemaFieldSets() {
      let fs = ['common']
      fs = fs.concat((this.schema && this.schema.fieldsets) ? this.schema.fieldsets.map(fieldSet => fieldSet.name) : [])
      return fs
    }
  },
  data: () => ({
    bucketConditions: [
      "Equal to",
      "Not Equal to",
      "Less Than",
      "More Than",
      "Less Than or Equal To",
      "More Than or Equal To",
      "Contains",
      "Before the last",
      "Within the last",
      "Within the next",
      "After the next",
      "Yesterday",
      "Today",
      "Tomorrow"
    ].map(operator =>
      ({ text: operator, value: operator.toLowerCase() })
    )
  }),
  methods: {
    async deleteFilter() {
      await this.$store.dispatch("deleteFilterField", this.filter)
    }
  }
}
</script>
